"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RejectResolutionDto = exports.CoreGetDisputesQueryDto = exports.CoreCreateDisputeDto = void 0;
// Note: Validation decorators should be added in backend services, not here
// This is a shared DTO used by both frontend and backend
// reason is only set when rejecting a resolution (reject-resolution endpoint), not on create
class CoreCreateDisputeDto {
    projectMilestoneId;
    disputeType;
    describeIssue;
    expectation; // Optional: if not provided, will use describeIssue
    desiredOutcome;
    /** ID businesses only, when desiredOutcome is CLIENT_RELEASE_FUNDS: the reason the client gives. */
    clientReleaseReason;
    /** Clients of ID companies only: the type of issue (HAN-638). */
    issueType;
    /**
     * Required: the milestone the dispute is about, or CORE_DISPUTE_NO_SPECIFIC_MILESTONE (HAN-637).
     * Only recorded on the dispute — locking and the dispute's link (projectMilestoneId) are unchanged.
     */
    milestoneInQuestionId;
    /** Business "Client to release funds" disputes only: full balance in escrow or another amount (HAN-692). */
    heldBackAmountType;
    /** Only sent with heldBackAmountType OTHER. For FULL_BALANCE the server works the amount out itself. */
    heldBackAmount;
}
exports.CoreCreateDisputeDto = CoreCreateDisputeDto;
class CoreGetDisputesQueryDto {
    projectId;
    projectMilestoneId;
    status;
    relations;
}
exports.CoreGetDisputesQueryDto = CoreGetDisputesQueryDto;
/** Used when rejecting a resolution (reject-resolution endpoint). Validation decorators applied in API layer. */
class RejectResolutionDto {
    reason;
}
exports.RejectResolutionDto = RejectResolutionDto;
